// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OAw_psrP2hgdQW941TtX{margin-top:-14px}.FA_50bN5KCg99dFHVnEb{margin-top:40px;margin-bottom:-2px}.IntKBnfZQPM6G0kkuhM4{align-items:flex-start;margin-top:24px}.DZbA7Xagm80SQWMhcePc{width:410px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"descriptionWrap": `OAw_psrP2hgdQW941TtX`,
	"image": `FA_50bN5KCg99dFHVnEb`,
	"declaration": `IntKBnfZQPM6G0kkuhM4`,
	"declarationText": `DZbA7Xagm80SQWMhcePc`
};
export default ___CSS_LOADER_EXPORT___;
